import React from 'react';

import type {UserMediaStatus} from '@pexip/media';

import type {
    BlockedBrowserPermissionsInfoType,
    DeviceError,
    DeviceStatusInfo,
} from '../../types';
import {PreflightInputControls} from '../InputControls/PreflightInputControls.view';

import {PreflightControlsWrapper} from './PreflightControlsWrapper.view';

export const PreflightMediaControls: React.FC<{
    audioInputControl?: React.ReactNode;
    deviceError: DeviceError;
    inputStatusInfo: DeviceStatusInfo;
    isAudioInputMuted: boolean;
    isAudioInputSuspended: boolean;
    isAudioInputUnavailable: boolean;
    isBlurred?: boolean;
    isMobileDevice: boolean;
    isRequestingAudio: boolean;
    isRequestingVideo: boolean;
    isVideoInputMuted: boolean;
    isVideoInputSuspended: boolean;
    isVideoInputUnavailable: boolean;
    learnHowToGrantAccessURL?: string;
    permissionInfoType: BlockedBrowserPermissionsInfoType;
    requestMediaPermissions: () => void;
    segmentationEnabled?: boolean;
    setShowHelpVideo: React.Dispatch<React.SetStateAction<boolean>>;
    shouldCenter: boolean;
    shouldShowVideoStatus?: boolean;
    silentTooltipInfo?: DeviceStatusInfo;
    streamStatus?: UserMediaStatus;
    toggleAudioInput?: () => void;
    toggleBlur?: () => void;
    toggleFacingMode?: () => void;
    toggleVideoInput?: () => void;
}> = ({
    audioInputControl,
    deviceError,
    inputStatusInfo,
    isAudioInputMuted,
    isAudioInputSuspended,
    isAudioInputUnavailable,
    isBlurred,
    isMobileDevice,
    isRequestingAudio,
    isRequestingVideo,
    isVideoInputMuted,
    isVideoInputSuspended,
    isVideoInputUnavailable,
    learnHowToGrantAccessURL,
    permissionInfoType,
    requestMediaPermissions,
    segmentationEnabled,
    setShowHelpVideo,
    shouldCenter,
    shouldShowVideoStatus,
    silentTooltipInfo,
    streamStatus,
    toggleAudioInput,
    toggleBlur,
    toggleFacingMode,
    toggleVideoInput,
}) => (
    <PreflightControlsWrapper
        position={shouldShowVideoStatus ? 'relative' : 'absoluteBottom'}
        isPhone={isMobileDevice}
        shouldCenter={shouldCenter}
    >
        <PreflightInputControls
            audioInputControl={audioInputControl}
            deniedDevice={deviceError.deniedDevice}
            inputStatusInfo={inputStatusInfo}
            isAudioInputMuted={isAudioInputMuted}
            isAudioInputSuspended={isAudioInputSuspended}
            isAudioInputUnavailable={isAudioInputUnavailable}
            isBlurred={isBlurred}
            isMobileDevice={isMobileDevice}
            isRequestingAudio={isRequestingAudio}
            isRequestingVideo={isRequestingVideo}
            isVideoInputMuted={isVideoInputMuted}
            isVideoInputSuspended={isVideoInputSuspended}
            isVideoInputUnavailable={isVideoInputUnavailable}
            learnHowToGrantAccessURL={learnHowToGrantAccessURL}
            permissionInfoType={permissionInfoType}
            requestMediaPermissions={requestMediaPermissions}
            segmentationEnabled={segmentationEnabled}
            setShowHelpVideo={setShowHelpVideo}
            silentTooltipInfo={silentTooltipInfo}
            streamStatus={streamStatus}
            toggleAudioInput={toggleAudioInput}
            toggleBlur={toggleBlur}
            toggleFacingMode={toggleFacingMode}
            toggleVideoInput={toggleVideoInput}
        />
    </PreflightControlsWrapper>
);

export type PreflightMediaControlsProps = React.ComponentProps<
    typeof PreflightMediaControls
>;
